import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import language resource files
import common_tw from './zh_TW/common.json';
import tools_tw from './zh_TW/tools.json';
import about_tw from './zh_TW/about.json';

import common_en from './en_US/common.json';
import tools_en from './en_US/tools.json';
import about_en from './en_US/about.json';


export const resources = {
    'en-US': {
        common: common_en,
        tools: tools_en,
        about: about_en,
    },
    'zh-TW': {
        common: common_tw,
        tools: tools_tw,
        about: about_tw,
    },
} as const;

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'zh-TW', // Default to Traditional Chinese if detection fails
        defaultNS: 'common', // Default namespace
        ns: ['common', 'tools', 'about'], // Declare all namespaces
        detection: {
            order: ['localStorage', 'navigator'], // Priority for language detection
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false, // React already protects from XSS
        },
    });

export default i18n;